// HelpModalContext.js
import React, { createContext, useContext, useState } from 'react';

const HelpModalContext = createContext();

export const useHelpModal = () => useContext(HelpModalContext);

export const HelpModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState('');
  const [onCloseCallback, setOnCloseCallback] = useState(null);

  const openHelpModal = (file, callback) => {
    setFileName(file);
    setIsOpen(true);
    setOnCloseCallback(() => callback);
  };

  const closeHelpModal = () => {
    setIsOpen(false);
    if (onCloseCallback) {
      onCloseCallback();
      setOnCloseCallback(null);
    }
  };

  return (
    <HelpModalContext.Provider value={{ isOpen, fileName, openHelpModal, closeHelpModal }}>
      {children}
    </HelpModalContext.Provider>
  );
};